/* eslint-disable no-use-before-define */

import { getBrand, getSessionId, show, isObject } from './twd'
const AbortController = window.AbortController

var TWDTOKEN = null
var tokenRefreshInterval

export const refreshTwdToken = async () => {
    let u = '/esb/generic/masterConfig/refreshToken?firstLoad=true&_dc=' + (new Date()).valueOf()
    let r = await fetch(u, {
        method: 'GET',
        headers: {
            SESSIONID: getSessionId()
        }
    })
    var token = 'CSRFTOKENERR'
    if (r.status===200) {
        token = r.headers.get('TWDTOKEN') || token
        if (token==='CSRFDISABLE' && tokenRefreshInterval) {
            clearInterval(tokenRefreshInterval)
        }
    }
    TWDTOKEN = token
}

export const initTwdToken = async () => {
    await refreshTwdToken()
    tokenRefreshInterval = setInterval(() => {
        refreshTwdToken()
    }, 30000)
}

export const ajax = (cfg = {}) => {
    let url = cfg.method === 'GET' ? toGetURL(cfg) : cfg.url

    let sid = getSessionId()

    let p = Object.assign({
        method: 'POST',
        headers: {
            BRAND: getBrand(),
            SESSIONID: sid,
            BD_REQUEST_ID: `${sid}.${(new Date()).getTime()}`,
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Cookie': document.cookie + '',
            ...(TWDTOKEN && {TWDTOKEN}),
            ...(cfg.headers_ || {})
        }
    }, cfg)


    if (p.method==='POST' && !('body' in p) && ('params' in p)) {
        let params = Array.isArray(p.params) ? p.params
            : (isObject(p.params) && Object.keys(p.params).length > 0) ? Object.fromEntries(
                Array.from(Object.entries(p.params))
                    .filter(([_,v]) => !(v instanceof HTMLElement))
                )
            : p.params
        p.body = JSON.stringify(params)
    }

    var timedOut = false
    let abort = new AbortController()
    p.signal = abort.signal
    if (p.timeout) {
        setTimeout(() => {
            timedOut = true
            abort.abort()
        }, p.timeout)
    }

    let data = fetch(url, p)
        .then(r => {
            if (r.status===401 && r.url.indexOf('bonddesk.com')>=0) {
                show('401')
                return
            }

            if (cfg.ignoreResponse) return

            return r
        })
        .then(r => r && (cfg.type==='text' ? r.text() : r.json()))

    return {
        data,
        abort: () => { abort.abort() },
        isTimedOut: () => timedOut
    }
}


const toGetURL = ({url, isDc=true, params={}}) => {
    let urls = url.split('?')
    let a = new URLSearchParams(urls[1] || '')
    let i = isDc ? {_dc:Date.now()} : {}
    let p = Object.assign(i, Object.fromEntries(a), params)
    let q = toQueryString(p)
    return urls[0] + '?' + q
}

export const toQueryString = (p={}) => {
    return Object.keys(p)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(p[k]))
        .join('&')
}
